export const TASK_POLL_INTERVAL_MS = 30000;
export const MAX_POLL_FAILURES = 5;
const SSE_RETRY_BASE_MS = 1000;
export const SSE_RETRY_MAX_MS = 15000;
export const SSE_MAX_ATTEMPTS = 8;

type PollFailure = "retry" | "lost" | "give_up";

export function classifyPollFailure(
  httpStatus: number | undefined,
  consecutiveFailures: number,
): PollFailure {
  if (httpStatus === 404) return "lost";
  if (httpStatus !== undefined && httpStatus < 500) return "give_up";
  return consecutiveFailures >= MAX_POLL_FAILURES ? "give_up" : "retry";
}

export function nextRetryDelay(attempt: number): number | null {
  if (attempt > SSE_MAX_ATTEMPTS) return null;
  return Math.min(SSE_RETRY_BASE_MS * 2 ** (attempt - 1), SSE_RETRY_MAX_MS);
}
